// ============================================================
//  BERANI GASTRO POŽADAVKY – zdrojová data
//  Snadné rozšíření: přidejte položky do polí níže
// ============================================================

export const CATEGORIES = [
  {
    id: 'vip',
    code: '01',
    name: 'VIP PROSTORY',
    tagline: 'Požadavky, přání a zpětná vazba k VIP cateringu',
    accent: '#FCD34D',
    icon: 'crown',
  },
  {
    id: 'restaurace',
    code: '02',
    name: 'RESTAURACE',
    tagline: 'Obědy, akce, catering a provozní požadavky restaurace',
    accent: '#1e3a8a',
    icon: 'utensils',
  },
  {
    id: 'bufety',
    code: '03',
    name: 'BUFETY',
    tagline: 'Sortiment, provoz, vybavení a zpětná vazba k bufetům',
    accent: '#10B981',
    icon: 'basket',
  },
];

export const REQUEST_TYPES = {
  vip: [
    'Zpětná vazba',
    'Přání / změna',
    'Objednávka občerstvení',
    'Speciální požadavek',
    'Nápoje',
    'Personál / obsluha',
    'Vybavení',
    'Problém / nedostatek',
    'Jiné',
  ],
  restaurace: [
    'Objednávka cateringu',
    'Obědy',
    'Hokejový turnaj',
    'Akce',
    'Rezervace restaurace',
    'Sortiment',
    'Provozní požadavek',
    'Zpětná vazba',
    'Problém / nedostatek',
    'Jiné',
  ],
  bufety: [
    'Sortiment',
    'Doplnění zboží',
    'Vybavení',
    'Provoz',
    'Personál',
    'Ceny',
    'Zpětná vazba',
    'Problém / nedostatek',
    'Návrh na změnu',
    'Jiné',
  ],
};

export const LOCATIONS = {
  vip: ['VIP Modrý', 'VIP Žlutý', 'Jiný'],
  bufety: ['Bufet 1', 'Bufet 2', 'Bufet 3', 'Bufet 4', 'Bufet 5', 'Bufet 6', 'Bufet 7', 'Jiný'],
};

export const REQUEST_STATUSES = [
  'nový',
  'přijatý',
  'řeší se',
  'čeká na klub',
  'vyřešený',
  'uzavřený',
];

export const STATUS_STYLE = {
  'nový':          { bg: 'bg-amber-100', text: 'text-amber-800', dot: 'bg-amber-500' },
  'přijatý':       { bg: 'bg-blue-100', text: 'text-blue-800', dot: 'bg-blue-500' },
  'řeší se':       { bg: 'bg-indigo-100', text: 'text-indigo-800', dot: 'bg-indigo-500' },
  'čeká na klub':  { bg: 'bg-purple-100', text: 'text-purple-800', dot: 'bg-purple-500' },
  'vyřešený':      { bg: 'bg-emerald-100', text: 'text-emerald-800', dot: 'bg-emerald-500' },
  'uzavřený':      { bg: 'bg-slate-200', text: 'text-slate-700', dot: 'bg-slate-500' },
};
